/**
 * @generated SignedSource<<943ed0ea699822d9e85ef680d39435b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingPhaseContext_ResumeMeetingRecordingMutation$variables = {
  noteId: string;
};
export type MeetingPhaseContext_ResumeMeetingRecordingMutation$data = {
  readonly resumeMeetingRecording: {
    readonly meetingRecordings: ReadonlyArray<{
      readonly id: string;
      readonly isCurrentlyRecording: boolean | null;
    }>;
  } | null;
};
export type MeetingPhaseContext_ResumeMeetingRecordingMutation = {
  response: MeetingPhaseContext_ResumeMeetingRecordingMutation$data;
  variables: MeetingPhaseContext_ResumeMeetingRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "ResumeMeetingRecording",
    "kind": "LinkedField",
    "name": "resumeMeetingRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecordings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCurrentlyRecording",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingPhaseContext_ResumeMeetingRecordingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingPhaseContext_ResumeMeetingRecordingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5cd07b2420ed151f5d8d3d384996fbe5",
    "id": null,
    "metadata": {},
    "name": "MeetingPhaseContext_ResumeMeetingRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingPhaseContext_ResumeMeetingRecordingMutation(\n  $noteId: ID!\n) {\n  resumeMeetingRecording(noteId: $noteId) {\n    meetingRecordings {\n      id\n      isCurrentlyRecording\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0adbd8d8c7a6fe6c6754ff03b8de6134";

export default node;
